export interface NgxCmModuleInfo {
    loadChildren: string;
    moduleId: string;
}
